import { Reducer } from 'redux/utils/List'

import actionTypes from './labResearchOrderTestResultListActionTypes'
import InitialState from './LabResearchOrderTestResultListInitialState'

export default Reducer({ actionTypes, stateClass: InitialState })